<div class="flex items-center justify-start gap-4 mb-6">
  <h2 class="text-xl font-semibold">La tua polizza su misura</h2>
  <button
    *ngIf="preventivo"
    class="bg-blue-600 text-white font-semibold px-4 py-2 rounded shadow hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
    [disabled]="isLoading"
    (click)="avantiStep()"
  >
    Conferma Preventivo >>
  </button>
</div>

<!-- Loader -->
<div *ngIf="isLoading" 
     class="mb-6 flex flex-col items-center justify-center text-gray-700 font-medium text-center">
  <svg class="animate-spin h-16 w-16 text-blue-500 mb-3"
       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10"
            stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
  </svg>
  <div class="text-gray-600 mt-2">
    <h3 class="mb-2">Sto cercando la soluzione migliore per te</h3>
    <p>Stiamo calcolando il tuo preventivo, l'operazione potrebbe richiedere fino a un minuto</p>
  </div>
</div>


<!-- Sezione Errore -->
<div *ngIf="errore" class="border border-red-300 bg-red-50 rounded-lg p-4 shadow mb-6">
  <div class="flex items-center gap-2 mb-2 text-red-700 font-semibold">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
    </svg>
    Abbiamo riscontrato degli errori!
  </div>
  <p class="text-sm text-red-600">{{ errore }}</p>
</div>

<!-- Sezione Preventivo trovato -->
<div *ngIf="preventivo" class="border border-green-700 rounded-lg shadow p-6 bg-white mb-6">
  <h3 class="text-lg text-green-700 mb-4">Abbiamo trovato la polizza perfetta per te!</h3>
  <p class="text-green-700 text-2xl">Importo: <strong>{{ preventivo.importo | currency:preventivo.valuta }}</strong></p>
  <p class="text-green-700 text-lg mt-4">Clicca sul tasto "Conferma Preventivo" per confermare il tuo preventivo e procedere con il contratto.</p>
</div>

<!-- Form Anagrafica -->
<div *ngIf="!preventivo && !isLoading" class="border border-gray-300 rounded-lg shadow p-6 bg-white">
  <h3 class="text-lg font-semibold mb-2">Dati per la quotazione</h3>
  <p class="mb-8">Inserisci qui sotto i dati per ricevere il tuo preventivo.</p>

  <form #form="ngForm" class="grid md:grid-cols-3 gap-4">

    <div>
      <label class="block font-medium mb-1">Ragione Sociale *</label>
      <input
        type="text"
        [(ngModel)]="ragioneSociale"
        name="ragioneSociale"
        required
        #ragioneSocialeRef="ngModel"
        [class.border-red-500]="ragioneSocialeRef.invalid && ragioneSocialeRef.touched"
        class="w-full border border-gray-300 rounded px-3 py-2"
      />
      <p *ngIf="ragioneSocialeRef.invalid && ragioneSocialeRef.touched" class="text-sm text-red-500 mt-1">
        Campo obbligatorio
      </p>
    </div>
    <div>
      <label class="block font-medium mb-1">Cognome *</label>
      <input
        type="text"
        [(ngModel)]="cognome"
        name="cognome"
        required
        #cognomeRef="ngModel"
        [class.border-red-500]="cognomeRef.invalid && cognomeRef.touched"
        class="w-full border border-gray-300 rounded px-3 py-2"
      />
      <p *ngIf="cognomeRef.invalid && cognomeRef.touched" class="text-sm text-red-500 mt-1">
        Campo obbligatorio
      </p>
    </div>
    <div>
      <label class="block font-medium mb-1">Nome *</label>
      <input
        type="text"
        [(ngModel)]="nome"
        name="nome"
        required
        #nomeRef="ngModel"
        [class.border-red-500]="nomeRef.invalid && nomeRef.touched"
        class="w-full border border-gray-300 rounded px-3 py-2"
      />
      <p *ngIf="nomeRef.invalid && nomeRef.touched" class="text-sm text-red-500 mt-1">
        Campo obbligatorio
      </p>
    </div>
    <div>
      <div class="flex gap-2 mt-4">
        <div class="w-1/4">
          <label class="block font-medium mb-1">Prefisso</label>
          <select
            [(ngModel)]="prefisso"
            name="prefisso"
            #prefissoRef="ngModel"
            [class.border-red-500]="prefissoRef.invalid && prefissoRef.touched"
            class="w-full border border-gray-300 rounded px-3 py-2"
          >
            <option *ngFor="let p of prefissiInternazionali" [value]="p.value">
              {{ p.flag }} {{ p.value }}
            </option>
          </select>
        </div>
        <div class="flex-1">
          <label class="block font-medium mb-1">Telefono</label>
          <input
            type="text"
            [(ngModel)]="telefono"
            name="telefono"
            #telefonoRef="ngModel"
            maxlength="15"
            pattern="^[0-9]{6,10}$"
            class="w-full border border-gray-300 rounded px-3 py-2"
            [class.border-red-500]="telefonoRef.invalid && telefonoRef.touched"
          />
          <p *ngIf="telefonoRef.invalid && telefonoRef.touched" class="text-red-500 text-sm">
            Numero di telefono non valido
          </p>
        </div>
      </div>
    </div>
    <div>
      <label class="block font-medium mt-4 mb-1">Email *</label>
      <input
        type="email"
        [(ngModel)]="email"
        name="email"
        required
        pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
        #emailRef="ngModel"
        [class.border-red-500]="emailRef.invalid && emailRef.touched"
        class="w-full border border-gray-300 rounded px-3 py-2"
      />
      <p *ngIf="emailRef.invalid && emailRef.touched" class="text-sm text-red-500 mt-1">
        Inserisci un'email valida (es. nome&#64;dominio.com)
      </p>
    </div>

    <!-- Checkbox Privacy -->
    <div class="col-span-1 md:col-span-2 mt-4">
      <label class="inline-flex items-start gap-2">
        <input
          type="checkbox"
          [(ngModel)]="privacyConsenso"
          required
          name="privacyConsenso"
          #privacyRef="ngModel"
          class="mt-1 accent-blue-600"
        />
        <span class="text-gray-700">
          Dichiaro di aver preso visione dell'<a class="font-bold underline" href="/privacy-policy" target="_blank">informativa privacy</a> e di prestare il consenso per la comunicazione dei dati personali con le modalità indicate al PUNTO 1 per le finalità di stipula di polizze assicurative, la comunicazione dei dati personali agli altri soggetti competenti indicati al PUNTO 4 per lo svolgimento degli obblighi normativi previsti e di aver preso visione ed accettare il contenuto dei <a class="font-bold underline" href="/termini-condizioni" target="_blank">termini e condizioni</a>.
        </span>
      </label>
      <p *ngIf="privacyRef.invalid && privacyRef.touched" class="text-sm text-red-500 mt-1">
        Devi accettare per continuare
      </p>
    </div>
    <div class="col-span-1 md:col-span-2 mt-4">
      <label class="inline-flex items-start gap-2">
        <input
          type="checkbox"
          [(ngModel)]="marketingConsenso"
          name="marketingConsenso"
          class="mt-1 accent-blue-600"
        />
        <span class="text-gray-700">
          Dichiaro di aver preso visione dell'<a class="font-bold underline" href="/privacy-policy" target="_blank">informativa privacy</a> e di prestare il consenso per la comunicazione dei dati personali con le modalità indicate al PUNTO 1 per finalità di marketing.
        </span>
      </label>
    </div>
  </form>

  <div class="mt-6">
    <button
      class="bg-green-600 text-white font-semibold px-6 py-2 rounded shadow hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
      (click)="richiediPreventivo()"
      [disabled]="!isAnagraficaValida()"
    >
      Richiedi Preventivo
    </button>
  </div>
</div>

<!-- Sezione Riepilogo Beni Assicurati -->
<div *ngIf="preventivo && voci.length > 0" class="mb-8">
  <h3 class="text-lg font-semibold mb-4 text-gray-800">Riepilogo Beni Assicurati</h3>
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
    <ng-container *ngFor="let voce of voci; let i = index">
      <div class="border border-blue-900 rounded-md p-3 text-sm">
        <h4 class="font-semibold text-base mb-2 text-gray-800">Bene {{ i + 1 }}: {{ voce.etichetta || voce.targa }}</h4>
        <p><strong class="text-gray-600">Targa / N. Patente:</strong> {{ voce.targa }}</p>
        <p><strong class="text-gray-600">Tipo patente:</strong> {{ voce.tipoPatente }}</p>
        <p><strong class="text-gray-600">Massimale:</strong> {{ massimale | number:'1.0-0' }} €</p>
        <p><strong class="text-gray-600">Diaria:</strong> {{ voce.diaria }} € × {{ voce.giorni }} giorni</p>
        <p><strong class="text-gray-600">Coperture:</strong></p>
        <ul class="list-disc list-inside text-gray-700">
          <li *ngFor="let c of voce.coperture">{{ c }}</li>
        </ul>
      </div>
    </ng-container>
  </div>
</div>
